import get from 'lodash/get';

const getConfig = (path, defaultValue) => {
  const config = window.config || {};
  if (!path) return config;
  return get(config, path, defaultValue);
};

export const getBaseUrl = () => {
  const prefixPath = getConfig('prefixPath');
  return window.location.origin + (prefixPath || '');
};

export default getConfig;
